// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import presupuestoFlotante from './routes/presupuesto-flotante';
import './formularios-itp/catalogos-vehiculos';
import './formularios-itp/catalogos-motos';
import './formularios-itp/catalogos-jetform';
import './formularios-itp/form-reset';
import './formularios-itp/form-sync-fields';
import './formularios-itp/form-conditional-required';
import './formularios-itp/form-email-match';
import './formularios-itp/form-nif-validation';
import './formularios-itp/form-imp-transferencia';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Presupuesto flotante
  presupuestoFlotante,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js